var map = {
	"./ar.svg": "./assets/icons/ar.svg",
	"./arrow_down.svg": "./assets/icons/arrow_down.svg",
	"./arrow_left.svg": "./assets/icons/arrow_left.svg",
	"./arrow_right.svg": "./assets/icons/arrow_right.svg",
	"./arrow_up.svg": "./assets/icons/arrow_up.svg",
	"./bag_active.svg": "./assets/icons/bag_active.svg",
	"./bag_default.svg": "./assets/icons/bag_default.svg",
	"./base_color.svg": "./assets/icons/base_color.svg",
	"./basket.svg": "./assets/icons/basket.svg",
	"./burgernav.svg": "./assets/icons/burgernav.svg",
	"./cart.svg": "./assets/icons/cart.svg",
	"./chairlegcolor.svg": "./assets/icons/chairlegcolor.svg",
	"./chairseatcolor.svg": "./assets/icons/chairseatcolor.svg",
	"./chairtype.svg": "./assets/icons/chairtype.svg",
	"./checkmark.svg": "./assets/icons/checkmark.svg",
	"./chevron_down.svg": "./assets/icons/chevron_down.svg",
	"./chevron_left.svg": "./assets/icons/chevron_left.svg",
	"./chevron_right.svg": "./assets/icons/chevron_right.svg",
	"./chevron_up.svg": "./assets/icons/chevron_up.svg",
	"./clean_big.svg": "./assets/icons/clean_big.svg",
	"./close.svg": "./assets/icons/close.svg",
	"./color.svg": "./assets/icons/color.svg",
	"./depth.svg": "./assets/icons/depth.svg",
	"./depth18.svg": "./assets/icons/depth18.svg",
	"./depth38.svg": "./assets/icons/depth38.svg",
	"./door_big.svg": "./assets/icons/door_big.svg",
	"./download.svg": "./assets/icons/download.svg",
	"./facebook.svg": "./assets/icons/facebook.svg",
	"./fallback_image.svg": "./assets/icons/fallback_image.svg",
	"./frame_color.svg": "./assets/icons/frame_color.svg",
	"./framecolor.svg": "./assets/icons/framecolor.svg",
	"./front.svg": "./assets/icons/front.svg",
	"./gallery.svg": "./assets/icons/gallery.svg",
	"./grid view.svg": "./assets/icons/grid view.svg",
	"./instagram.svg": "./assets/icons/instagram.svg",
	"./linkedin.svg": "./assets/icons/linkedin.svg",
	"./logo.svg": "./assets/icons/logo.svg",
	"./logo_inverted.svg": "./assets/icons/logo_inverted.svg",
	"./minus.svg": "./assets/icons/minus.svg",
	"./pinterest.svg": "./assets/icons/pinterest.svg",
	"./place.svg": "./assets/icons/place.svg",
	"./placemap.svg": "./assets/icons/placemap.svg",
	"./play btn.svg": "./assets/icons/play btn.svg",
	"./plus.svg": "./assets/icons/plus.svg",
	"./position.svg": "./assets/icons/position.svg",
	"./quote.svg": "./assets/icons/quote.svg",
	"./raw.svg": "./assets/icons/raw.svg",
	"./rotate.svg": "./assets/icons/rotate.svg",
	"./search.svg": "./assets/icons/search.svg",
	"./search_active.svg": "./assets/icons/search_active.svg",
	"./selected.svg": "./assets/icons/selected.svg",
	"./shellfinish.svg": "./assets/icons/shellfinish.svg",
	"./shelves.svg": "./assets/icons/shelves.svg",
	"./shelves_big.svg": "./assets/icons/shelves_big.svg",
	"./specs.svg": "./assets/icons/specs.svg",
	"./table_frame.svg": "./assets/icons/table_frame.svg",
	"./table_top.svg": "./assets/icons/table_top.svg",
	"./top.svg": "./assets/icons/top.svg",
	"./twitter.svg": "./assets/icons/twitter.svg",
	"./units.svg": "./assets/icons/units.svg",
	"./up_down.svg": "./assets/icons/up_down.svg",
	"./upholsterytype.svg": "./assets/icons/upholsterytype.svg",
	"./volume-mute.svg": "./assets/icons/volume-mute.svg",
	"./volume-up.svg": "./assets/icons/volume-up.svg",
	"./youtube.svg": "./assets/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/icons sync recursive ^\\.\\/.*\\.svg$";